import { Ca1Model } from './ca1.model';
import { SocieteLinkedModel } from './societe-linked.model';

export class SiteModel extends SocieteLinkedModel {
    // max-length 12
    rSociale: string;
    // max-length 30
    adr1: string;
    // max-length 30
    adr2: string;
    // max-length 30
    adr3: string;
    // max-length 30
    adrFact1: string;
    // max-length 30
    adrFact2: string;
    // max-length 30
    adrFact3: string;
    // max-length 30
    tel: string;
    // max-length 30
    fax: string;
    // max-length 30
    type: string;
    // max-length 30
    // max-length 9
    siret1: string;
    // max-length 9
    siret2: string;
    // max-length 5
    naf: string;

    idCa1?: number;

    ca1?: Ca1Model;

    email: string;
}
